import { SET_STATUS_FILTER, SET_COLUMN_FILTERS, RESET_COLUMN_FILTERS, LOGOUT } from "../actionTypes";

export const setStatusFilter = (screen, data) => ({
  type: SET_STATUS_FILTER,
  payload: {
    screen,
    data
  }
});

export const setColumnFilters = (screen, columnKey, options) => ({
  type: SET_COLUMN_FILTERS,
  payload: {
    screen,
    columnKey,
    options: Array.isArray(options) ? options : []
  }
});

export const resetColumnFilters = (screen) => ({
  type: RESET_COLUMN_FILTERS,
  payload: { screen }
});
